import { RetryOptions } from '@reduxjs/toolkit/dist/query/retry'
import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'
import { useTranslation } from 'react-i18next'
import { RootState } from 'redux/store'
import { setAuth } from 'redux/store/slices/auth-slice'
import { setError } from 'redux/store/slices/error-slice'
import { setRequestTimestamp } from 'redux/store/slices/requestTimer'
import { PURGE } from 'redux-persist'

export const APIUrl = import.meta.env.NR_API_URL
export const NRAPIUrl = import.meta.env.NR_NONRESIDENT_API_URL

console.log('APIUrl', import.meta.env)

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, RetryOptions, FetchBaseQueryMeta> =
  fetchBaseQuery({
    baseUrl: APIUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.access
      if (token) headers.set('Authorization', `JWT ${token}`)
      headers.set('Accept', 'application/json')
      return headers
    },
    mode: 'cors'
  })

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(args, api, extraOptions)
  const lastRequestDate = new Date(api.getState().requestTimestamp.lastRequestTime)
  const refresh = api.getState().auth.refresh

  //15 * 60 * 1000 = 900000 15 minutes in milliseconds
  // console.log('lastRequestDate', Math.abs(new Date() - lastRequestDate));

  const timeDifferenceMoreThan15 = Math.abs(new Date() - lastRequestDate) > 15 * 60 * 1000

  if (
    result.error?.status === 429 ||
    result.error?.status === 'FETCH_ERROR' ||
    result.error?.status === 'PARSING_ERROR' ||
    result.error?.status === 500
  ) {
    api.dispatch(
      setError({
        code: 'FETCH_ERROR',
        description: ''
      })
    )
  }
  if (result.error && result.error.status === 401) {
    if (!timeDifferenceMoreThan15 && refresh) {
      // const result = await api.dispatch(refreshApi.endpoints.refresh.initiate(null, { forceRefetch: true }));
      try {
        const refreshResult = await fetch(`${APIUrl}/auth/refresh/`, {
          method: 'POST',
          body: JSON.stringify({ refresh }),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        if (refreshResult.status === 200) {
          // store the new token
          const accessResponse = await refreshResult.json()
          console.log('accessResponse', accessResponse)

          api.dispatch({ type: 'auth/setAuth', payload: accessResponse })
          // retry the initial query
          result = await baseQuery(args, api, extraOptions)
        }
      } catch (error) {
        await api.dispatch({ type: PURGE, result: () => null })
      }
    } else {
      console.log('The interval is greater than 15 minutes.')
      await api.dispatch({ type: PURGE, result: () => null })
      result = await baseQuery(args, api, extraOptions)
      window.open(import.meta.env.NR_HOMEPAGE, '_self')
    }

    // await api.dispatch({ type: PURGE, result: () => null });
    // result = await baseQuery(args, api, extraOptions);
  }
  if (result.error && result.error.status === 401) {
    await api.dispatch({ type: PURGE, result: () => null })
    result = await baseQuery(args, api, extraOptions)
  }
  if (result.data?.data || result.error?.data) {
    api.dispatch(setRequestTimestamp(new Date()))
  }
  return result
}
export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({})
})

const nonresidentBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  RetryOptions,
  FetchBaseQueryMeta
> = fetchBaseQuery({
  baseUrl: NRAPIUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.access
    if (token) headers.set('Authorization', `JWT ${token}`)
    headers.set('Accept', 'application/json')
    return headers
  },
  mode: 'cors'
})

export const nonresidentApi = createApi({
  reducerPath: 'apiNonResident',
  baseQuery: nonresidentBaseQuery,
  endpoints: () => ({})
})
